import React, { useState } from "react";
import clsx from "clsx";

/**
 * Envuelve un control del overlay del PDF y dibuja su anillo de foco (ver
 * `.pdf-field-focus-ring` en _forms.scss). Los inputs y textareas no admiten
 * ::before/::after, y dibujar el gradiente aparte no cambia el tamano del control
 * ni corre su texto.
 *
 * El anillo se muestra con los eventos focus/blur del control y no con un selector
 * de hermanos (`:focus + .anillo`): las extensiones de correccion ortografica
 * (Grammarly, LanguageTool...) insertan su propio elemento justo despues de cada
 * textarea, y eso rompia el selector solo en las areas de texto.
 */
const FieldFocusRing = ({ cssCoords, children }) => {
    const [isFocused, setIsFocused] = useState(false);
    const control = React.Children.only(children);

    return (
        <>
            {React.cloneElement(control, {
                onFocus: (event) => {
                    setIsFocused(true);
                    control.props.onFocus?.(event);
                },
                onBlur: (event) => {
                    setIsFocused(false);
                    control.props.onBlur?.(event);
                },
            })}
            <span
                className={clsx("pdf-field-focus-ring", { "is-visible": isFocused })}
                aria-hidden="true"
                style={{ top: cssCoords.top, left: cssCoords.left, width: cssCoords.width, height: cssCoords.height }}
            />
        </>
    );
};

/**
 * onMouseDown de las casillas, radios y listas. Safari, y Firefox en macOS, siguen
 * la convencion del sistema y no les dan el foco al hacer clic (solo con Tab), asi
 * que sin esto su anillo nunca aparece. En Chrome ya tienen el foco: no cambia nada.
 */
export const focusOnMouseDown = (event) => {
    if (document.activeElement !== event.currentTarget) event.currentTarget.focus({ preventScroll: true });
};

export default FieldFocusRing;
